import Container from 'components/container';
import { FC } from 'react';

import { FooterCopyRight } from './FooterCopyRight';
import { FooterNavigations } from './FooterNavigations';

const Footer: FC = () => {
  return (
    <div className='bg-[#f9f9f9] pt-[50px]'>
      <Container className='!px-0 pb-10'>
        <FooterNavigations />
      </Container>
      <FooterCopyRight />
    </div>
  );
};

export default Footer;
